<div
  class="list-tasks-single-task {{ 'list-tasks-single-task--' + task()?.status }}"
  [ngClass]="{ 'list-tasks-single-task--subtask': isSubtask }"
  [dndDraggable]="
    shouldBeDraggable() ? { taskId: task().id, sourceGroupId: groupId(), sourceStatus: status() } : null
  "
  [dndDisableIf]="isProcessGroup() || !shouldBeDraggable()"
  dndType="task-v2"
  dndEffectAllowed="copyMove"
>
  <div class="list-tasks-single-task__container">
    @if (!isProcessGroup()) {
      <div class="drag-handle" [class.hidden]="!shouldBeDraggable()" dndHandle>
        <img width="12" src="./assets/img/ic-sortdragchange.svg" alt="drag-drop" />
      </div>
    }

    <div class="list-tasks-single-task__content {{ 'list-tasks-single-task__content--' + task()?.status }}">
      <div class="list-tasks-single-task__content__expander">
        <expander
          [opened]="task()?.openedSubtasks"
          (onClick)="toggleSubtasks()"
          *ngIf="task()?.childrenCount"
        />
      </div>

      @if (isSubtask) {
        <mat-icon class="subtask-icon">subdirectory_arrow_right</mat-icon>
      }

      <mat-checkbox
        class="list-tasks-single-task__content__checkbox"
        [class.subtask-checkbox]="isSubtask"
        [checked]="isCompleted()"
        [disabled]="isCancelled()"
        (change)="onStatusChange($event)"
      />

      <div class="list-tasks-single-task__content__assignee">
        <avatar-multiple
          [assignSearchDropdownTask]="task()?.project?.id ? task() : null"
          [items]="assignedUsers"
          [width]="24"
          [disabledSearch]="!task()?.project?.id"
          (onAssignSearchDropdownTaskChange)="onAssignSearchDropdownTaskChange($event)"
        />
      </div>

      <div
        class="list-tasks-single-task__content__title d-flex {{
          'list-tasks-single-task__content__title--' + task()?.status
        }}"
      >
        <a draggable="false" href="javascript:void(0)" (click)="previewTask($event)">
          {{ task()?.description }}
        </a>

        @if (task()?.hiddenForClient) {
          <svg-icon
            [title]="'ProjectTasks.Task.hiddenFromClient' | translate"
            class="ml-1"
            src="./assets/img/ic-eye-off.svg"
            [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
          />
        }
      </div>

      @if (task()?.type) {
        <div class="list-tasks-single-task__content__type pr-2" [ngClass]="getTaskTypeCssClass()">
          {{ getTaskTypeTranslationKey() | translate }}
        </div>
      }

      @if (task()?.childrenCount) {
        <div class="list-tasks-single-task__content__amount cursor-pointer" (click)="toggleSubtasks()">
          <svg-icon [src]="'./assets/img/ic-subtask.svg'" [svgStyle]="{ width: '16px', height: '16px' }" />
          {{ task()?.completedChildrenCount ?? 0 }}/{{ task()?.childrenCount ?? 0 }}
        </div>
      }
    </div>

    <div
      class="list-tasks-single-task__info flex-wrap"
      [class.list-tasks-single-task__info--completed]="!isProcessGroup() && task()?.status === 'completed'"
      [class.list-tasks-single-task__info--cancelled]="!isProcessGroup() && task()?.status === 'cancelled'"
      [class.list-tasks-single-task__info--canceled]="!isProcessGroup() && task()?.status === 'canceled'"
    >
      @if (task()?.termEnd) {
        @if (showProcessDeadlineTag()) {
          <div class="list-tasks-single-task__info__deadline-tag">
            {{ 'Tasks.deadlineLabel' | translate }}: {{ task()?.termEnd | dateFormat: 'DD.MM.YYYY' }}
          </div>
        } @else {
          <div class="list-tasks-single-task__info__deadline">
            @if (!task()?.termStartTheSameTermEnd) {
              {{ task()?.termStart | dateFormat: 'DD MMM' }} - {{ task()?.termEnd | dateFormat: 'DD MMM' }}
            }

            @if (task()?.termStartTheSameTermEnd) {
              {{ task()?.termEnd | dateFormat: 'DD MMM' }}
            }
          </div>
        }
      }

      @if (isProcessMessageTask()) {
        @if (isProcessMessageSent() || isProcessMessageScheduled()) {
          <div class="list-tasks-single-task__info__mail-meta">
            <div class="list-tasks-single-task__info__mail-sender">
              <avatar [imageUrl]="processMessageSenderAvatar" [width]="24" [height]="24" [rounded]="true" />
              <span>{{ processMessageSenderName }}</span>
            </div>

            <div class="list-tasks-single-task__info__mail-sent-at">
              {{
                isProcessMessageScheduled()
                  ? ('Tasks.messageScheduledAt' | translate)
                  : ('Tasks.messageSentAt' | translate)
              }}:
              {{ task()?.mailScheduledAt || task()?.mailSentAt | dateFormat: 'DD.MM.YYYY - HH:mm' }}
            </div>
          </div>
        } @else {
          <div class="list-tasks-single-task__info__deadline-tag">
            {{ 'Tasks.messageNotSent' | translate }}
          </div>
        }
      } @else if (shouldShowStatusMeta) {
        <div class="list-tasks-single-task__info__mail-meta">
          <div class="list-tasks-single-task__info__mail-sender">
            <avatar [imageUrl]="statusChangedByAvatar" [width]="24" [height]="24" [rounded]="true" />
            <span>{{ statusChangedByName }}</span>
          </div>

          <div class="list-tasks-single-task__info__mail-sent-at">
            {{ statusMetaLabelKey | translate }}:
            {{ statusMetaDate | dateFormat: 'DD.MM.YYYY - HH:mm' }}
          </div>
        </div>
      }

      <status-reason
        *ngIf="task()?.status === TaskStatus.CANCELLED"
        [label]="'Projects.TaskStatus.' + task()?.status | translate"
        color="dark-grey"
        [colorForText]="true"
      />
    </div>
  </div>
</div>

@if (task()?.openedSubtasks) {
  <div
    class="list-tasks-single-task__subtasks-container"
    [ngClass]="{ 'list-tasks-single-task__subtasks-container--opened': task()?.openedSubtasks }"
  >
    <ng-container *ngFor="let subtask of task()?.children; trackBy: identify">
      <list-tasks-v2-single-task
        *ngIf="!subtask?.deleted"
        [task]="subtask"
        [groupId]="groupId()"
        [isProcessGroup]="isProcessGroup()"
        [status]="childStatus(subtask)"
        [parentTask]="task()"
        (statusUpdated)="statusUpdated.emit($event)"
        (taskClicked)="taskClicked.emit($event)"
      />
    </ng-container>
  </div>
}
